// Module
var code = `<div class="information-bar" ng-if="\$ctrl.message">
  <h2>System information</h2>
  {{\$ctrl.message}}
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/technical/information-bar/information-bar.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;